export * from './carousel-gallery.component';
